import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getUserOnboarding, updateUserOnboarding, type UserOnboardingPatch } from '../../../api/userOnboarding';

export const USER_ONBOARDING_KEY = ['me', 'onboarding'] as const;

export const useUserOnboardingQuery = (enabled = true) =>
  useQuery({ queryKey: USER_ONBOARDING_KEY, queryFn: getUserOnboarding, enabled });

/** Every choice is saved as it is made, so the user can leave and come back */
export const useUpdateUserOnboardingMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (changes: UserOnboardingPatch) => updateUserOnboarding(changes),
    onSuccess: (onboarding) => queryClient.setQueryData(USER_ONBOARDING_KEY, onboarding),
  });
};
